export const getTypeOfConcernOptions = (typeOfConcern: string) => {
  switch (typeOfConcern) {
    case 'Building':
      return ['Structural', 'Various Works (Structural)', 'Others']
    case 'Interior':
      return [
        'Architectural',
        'Electrical',
        'Modular',
        'Plumbing & Sanitary',
        'Various Works (Interior)',
        'Others',
      ]
    case 'Exterior':
      return [
        'ACP',
        `Dealer's Name & Address`,
        'Lighted Signage',
        'Service Signage',
        'Timer',
        'Vertical Signage',
        'Various Works (Exterior)',
        'Others',
      ]
    case 'Appliance':
      return [
        'Air-Conditioning Unit',
        'Computer System - Parts',
        'Generator Set',
        'Industrial Fan',
        'Mixing Amplifier',
        'Smart TV',
        'Speaker',
        'Uninterruptable Power Supply - Computer',
        'Water Dispenser',
        'Others',
      ]
    case 'Collateral':
      return [
        'Barcelona Sofa Chair',
        'Collapsible Tent Frame',
        'Collapsible Tent Roofing',
        'Dealer Certificate',
        'Digital Wall Clock',
        'Dirt Rags',
        'Flag Pole',
        'Garbage Segregation Bin',
        'Mannequin',
        'MC Center Stand',
        'Movable Billboard',
        'Multi Purpose Ladder',
        'Nego Chair (Black)',
        'Nego Chair (White)',
        'Nego Table',
        'Pinbadge Frame',
        'Showroom Mirror',
        'Specification Sheet Holder',
        'Stainless Banner Stand',
        'Stainless High Round Table',
        'Stainless Tall Chair',
        'Others',
      ]
    default:
      return []
  }
}
